export default {
  className: 'downloadCenter',
  fields: [
    {
      name: 'file',
      note: '视频',
      tooltip: '部分mov格式视频不支持保存到相册',
      validators: [
        (val) => val ? null : '下载视频不可为空'
      ]
    },
    {
      name: 'downloads',
      tooltip: '根据用户下载次数显示，无需编辑',
      disabled: true
    }
  ],
  hooks: {
    /**
     * 給查询添加条件
     * @date: 2020/3/9
     */
    beforeFetch ({ where, modelName }) {
      where.type = 'video'
    },
    // 保存数据前判断
    async beforeSave (options) {
      let data = options.data
      // 判断是否有空值
      data.type = 'video'
    }
  }
}
